/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Ready_HintInputs */

const en_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every lesson is one-on-one with Mark. Book online, 24/7.`)
};

const es_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada lección es uno a uno con Mark. Reserva en línea, 24/7.`)
};

const de_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Unterrichtsstunde ist Einzelunterricht mit Mark. Buchen Sie rund um die Uhr online.`)
};

const zh_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每节课都是与 Mark 一对一的。在线预订，24/7。`)
};

const ar_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل درس فردي مع Mark. احجز عبر الإنترنت على مدار الساعة.`)
};

const fr_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque leçon est individuelle avec Mark. Réservez en ligne, 24h/24 et 7j/7.`)
};

const vi_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mỗi bài học là một kèm một với Mark. Đặt trực tuyến, 24/7.`)
};

const sw_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kila somo ni la mtu mmoja na Mark. Weka nafasi mtandaoni, 24/7.`)
};

const th_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกบทเรียนเป็นแบบตัวต่อตัวกับ Mark จองออนไลน์ทุกวันตลอด 24 ชั่วโมง`)
};

const bs_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Svaka lekcija je individualna s Markom. Rezervišite online, 24/7.`)
};

const ja_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンはすべてMarkとのマンツーマンです。オンラインで24時間予約できます。`)
};

const ko_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 레슨은 Mark와 함께하는 1:1 개인 레슨입니다. 온라인 예약, 24/7.`)
};

const pt_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as aulas são individuais com o Mark. Agende online, 24/7.`)
};

const it_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni lezione è individuale, solo tu e Mark. Prenota online, 24/7.`)
};

const sv_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varje lektion är en-till-en med Mark. Boka online, 24/7.`)
};

const nl_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke les is één op één met Mark. Boek online, 24/7.`)
};

const da_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver lektion er en-til-en med Mark. Book online, 24/7.`)
};

const nb_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hver leksjon er én-til-én med Mark. Bestill på nettet, 24/7.`)
};

const fi_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jokainen tunti on kahdenkeskinen Markin kanssa. Varaa netistä, 24/7.`)
};

const pl_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda lekcja to zajęcia jeden na jeden z Markiem. Zarezerwuj online, 24/7.`)
};

const ru_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый урок проходит один на один с тренером Mark. Бронируйте онлайн, 24/7.`)
};

const tr_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her ders Mark ile birebir. 7/24 online rezervasyon yapın.`)
};

const hi_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हर पाठ Mark के साथ आमने-सामने होता है। ऑनलाइन बुक करें, 24/7।`)
};

const id_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap pelajaran bersifat privat bersama Mark. Pesan online, 24/7.`)
};

const ms_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap pelajaran ialah sesi peribadi bersama Mark. Tempah dalam talian, 24/7.`)
};

const cs_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Každá lekce je jedna na jednoho s Markem. Rezervujte online, 24/7.`)
};

const el_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κάθε μάθημα είναι ιδιαίτερο, ένας προς έναν με τον Mark. Κάντε κράτηση online, 24/7.`)
};

const he_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כל שיעור הוא אחד על אחד עם Mark. הזמינו אונליין, 24/7.`)
};

const af_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke les is een-tot-een met Mark. Boek aanlyn, 24/7.`)
};

const hu_method_ready_hint = /** @type {(inputs: Method_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden óra négyszemközti Markkal. Foglaljon online, 24/7.`)
};

/**
* | output |
* | --- |
* | "Every lesson is one-on-one with Mark. Book online, 24/7." |
*
* @param {Method_Ready_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_ready_hint = /** @type {((inputs?: Method_Ready_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Ready_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_ready_hint(inputs)
	if (locale === "de") return de_method_ready_hint(inputs)
	if (locale === "zh") return zh_method_ready_hint(inputs)
	if (locale === "ar") return ar_method_ready_hint(inputs)
	if (locale === "fr") return fr_method_ready_hint(inputs)
	if (locale === "vi") return vi_method_ready_hint(inputs)
	if (locale === "sw") return sw_method_ready_hint(inputs)
	if (locale === "th") return th_method_ready_hint(inputs)
	if (locale === "bs") return bs_method_ready_hint(inputs)
	if (locale === "ja") return ja_method_ready_hint(inputs)
	if (locale === "ko") return ko_method_ready_hint(inputs)
	if (locale === "pt") return pt_method_ready_hint(inputs)
	if (locale === "it") return it_method_ready_hint(inputs)
	if (locale === "sv") return sv_method_ready_hint(inputs)
	if (locale === "nl") return nl_method_ready_hint(inputs)
	if (locale === "da") return da_method_ready_hint(inputs)
	if (locale === "nb") return nb_method_ready_hint(inputs)
	if (locale === "fi") return fi_method_ready_hint(inputs)
	if (locale === "pl") return pl_method_ready_hint(inputs)
	if (locale === "ru") return ru_method_ready_hint(inputs)
	if (locale === "tr") return tr_method_ready_hint(inputs)
	if (locale === "hi") return hi_method_ready_hint(inputs)
	if (locale === "id") return id_method_ready_hint(inputs)
	if (locale === "ms") return ms_method_ready_hint(inputs)
	if (locale === "cs") return cs_method_ready_hint(inputs)
	if (locale === "el") return el_method_ready_hint(inputs)
	if (locale === "he") return he_method_ready_hint(inputs)
	if (locale === "af") return af_method_ready_hint(inputs)
	if (locale === "hu") return hu_method_ready_hint(inputs)
	return en_method_ready_hint(inputs)
});